import React, { useEffect, useRef } from "react";
import { Checkbox, Dropdown, Popup } from "semantic-ui-react";
import { ClearableRating } from "./ClearableRating";

function Color({ color }) {
  return (
    <div
      style={{
        width: 140,
        height: 20,
        border: "thin solid black",
        backgroundColor: color,
      }}
    />
  );
}

export function AlbumsCounter({ count, colors, filter, onFilter }) {
  const availableColors = useRef([]);

  useEffect(() => {
    availableColors.current = colors.map((color, i) => ({
      key: i,
      text: <Color color={color} />,
      value: i,
      content: <Color color={color} />,
    }));
  }, [colors]);

  const options = availableColors.current;

  return (
    <Popup
      on="click"
      trigger={<div className="albums-count">{`${count} albums`}</div>}
      position="bottom right"
    >
      <Popup.Content
        style={{ display: "flex", flexDirection: "column", gap: 3 }}
      >
        <Dropdown
          clearable
          selection
          options={options}
          value={filter.value}
          onChange={(_ev, data) =>
            onFilter(data.value, colors[data.value], filter.rating, filter.showEmpty)
          }
        />
        <ClearableRating
          value={filter.rating}
          onChange={(rating) => onFilter(filter.value, filter.color, rating, filter.showEmpty)}
        />
        <Checkbox
          toggle
          label="Show empty albums"
          checked={filter.showEmpty}
          onChange={(_, {checked}) => onFilter(filter.value, filter.color, filter.rating, checked)}
        />
      </Popup.Content>
    </Popup>
  );
}
